/**
 * Unified date formatting utility for BIGBUS application
 * Format: yyyy/mm/dd
 */

/**
 * Format date to yyyy/mm/dd
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted date string in yyyy/mm/dd format
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return '';
  
  try {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    
    if (isNaN(date.getTime())) {
      return '';
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}/${month}/${day}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Format date to yyyy/mm/dd HH:mm
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted date string with time
 */
export const formatDateTime = (dateInput) => {
  if (!dateInput) return '';
  
  try {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    
    if (isNaN(date.getTime())) {
      return '';
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}/${month}/${day} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Error formatting date time:', error);
    return '';
  }
};

/**
 * Convert date to yyyy-mm-dd format for HTML date input
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Date in yyyy-mm-dd format for input[type="date"]
 */
export const toInputDateFormat = (dateInput) => {
  if (!dateInput) return '';
  
  try {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    
    if (isNaN(date.getTime())) {
      return '';
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting to input date format:', error);
    return '';
  }
};

/**
 * Get today's date in yyyy-mm-dd format for input default
 * @returns {string} Today's date
 */
export const getTodayInputFormat = () => {
  return toInputDateFormat(new Date());
};
